import { render, staticRenderFns } from "./selectPackage.vue?vue&type=template&id=9a7467b2&scoped=true"
import script from "./selectPackage.vue?vue&type=script&lang=ts"
export * from "./selectPackage.vue?vue&type=script&lang=ts"
import style0 from "./selectPackage.vue?vue&type=style&index=0&id=9a7467b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7467b2",
  null
  
)

export default component.exports